import axios from "axios";
import qs from "qs";
import { Attempt, User } from "./models";
import { FORCE_PREMIUM } from "./constants";

export const register = async (username: string, email: string, password: string, attempts: Attempt[]) => {
    return axios.post(
        `${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/register`,
        qs.stringify({
            username,
            email,
            password,
            registerSite: "openingTrainer",
            attempts,
        }),
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
    );
};

export const login = async (username: string, password: string) => {
    await axios.post(
        `${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/login`,
        qs.stringify({
            username,
            password,
        }),
        {
            withCredentials: true,
        },
    );
};

export const signOut = async () => {
    await axios.get(`${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/signout`, {
        withCredentials: true,
    });
};

export const getUser = async (): Promise<User> => {
    const res = await axios.get(`${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/user`, {
        withCredentials: true,
    });

    return res.data;
};

export const paywall = async (user?: User) => {
    if (FORCE_PREMIUM) {
        return false;
    }

    if (!user || !user.isPremium) {
        window.location.href = "/premium";
        return true;
    }

    if (!user) {
        user = await getUser();
        if (!user) {
            window.location.href = "/register";
            return true;
        }
    }
};

export const redirectToPremiumIfNotPremium = (user?: User) => {
    if (FORCE_PREMIUM || !user) {
        return;
    }

    if (user?.isPremium === false) {
        window.location.href = "/premium";
        return;
    }
};

export const handleOnCheckout = async (product: string) => {
    const res = await axios.post(
        `${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/create-checkout-session`,
        {
            lookup_key: product,
            domain: import.meta.env.VITE_OPENING_TRAINER_URL,
            purchaseSite: "openingTrainer",
        },
        {
            headers: {
                "Content-Type": "application/json",
            },
            withCredentials: true,
        },
    );

    const url = res.data.url;
    window.location.href = url;
};

export const forgotPassword = async (email: string) => {
    return axios.post(`${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/forgot-password`, qs.stringify({ email }), {
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
};

export const resetPassword = async (token: string, newPassword: string) => {
    return axios.post(
        `${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/reset-password`,
        qs.stringify({ token, newPassword }),
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
    );
};

export const postLoggedOutAttempts = async (attempts: Attempt[]) => {
    return axios.post(
        `${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/ot_logged_out_attempts`,
        qs.stringify({
            attempts,
        }),
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            withCredentials: true,
        },
    );
};
